import { render, staticRenderFns } from "./DbProductDelete.vue?vue&type=template&id=47b219ad"
import script from "./DbProductDelete.vue?vue&type=script&lang=ts"
export * from "./DbProductDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports